import { isAbsoluteUrl, isRelativeUrl } from '@piri/utils';
import { isIframe, isSoundcloudIframe } from '@/helpers/media/embed';
import { isValidTwitterHandle } from '@/helpers/normalizeTwitterHandle';

export const minLength = {
  validate(array, minCount) {
    return array.length >= minCount[0];
  },
};

export const maxLength = {
  validate(array, maxCount) {
    return array.length <= maxCount[0];
  },
};

export const decimal = {
  validate(value, { decimals = '*', separator = '.' }) {
    if (value === null || value === undefined || value === '') {
      return {
        valid: false,
      };
    }

    if (Number(decimals) === 0) {
      return {
        valid: /^-?\d*$/.test(value),
      };
    }

    const regexPart = decimals === '*' ? '+' : `{1,${decimals}}`;
    const regex = new RegExp(`^[-+]?\\d*(\\${separator}\\d${regexPart})?([eE]{1}[-]?\\d+)?$`);

    return {
      valid: regex.test(value),
    };
  },
};

export const iframe = {
  validate(embedCode) {
    return isIframe(embedCode);
  },
};

export const soundcloudIframe = {
  validate(embedCode) {
    return isSoundcloudIframe(embedCode);
  },
};

export const nullableEmail = {
  validate(email) {
    return /(^$|^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,})+$)/.test(email.toLowerCase());
  },
};

export const nullableTwitter = {
  validate(twitter) {
    return isValidTwitterHandle(twitter);
  },
};

export const nullableInstagram = {
  validate(instagram) {
    return /^[\w.]{0,29}$/.test(instagram);
  },
};

export const nullableFacebook = {
  validate(facebook) {
    return /^[\w.]{5,}$/.test(facebook);
  },
};

export const nullableYoutube = {
  validate(youtube) {
    return /^[\w.]{3,30}$/.test(youtube);
  },
};

export const nullableTiktok = {
  validate(tiktok) {
    return /^[\w.]{0,23}$/.test(tiktok);
  },
};

export const waitUpload = {
  validate(value, { multiple }) {
    return {
      valid: multiple ? value.filter(file => file.isUploading).length <= 0 : !value.isUploading,
    };
  },
  params: ['multiple'],
};

export const url = {
  validate(value) {
    return !value || (isAbsoluteUrl(value) || isRelativeUrl(value));
  },
};

export const absoluteUrl = {
  validate(value) {
    return !(value && !isAbsoluteUrl(value));
  },
};

export const relativeUrl = {
  validate(value) {
    return !(value && !isRelativeUrl(value));
  },
};

export const hasCoverImage = {
  validate(value) {
    return !(value && !value.coverImage);
  },
};

export const isUploading = {
  validate(value) {
    return !value;
  },
};

export const validCropSettings = {
  validate(value) {
    return value;
  },

};
export const rel = {
  validate(value) {
    return value === 'nofollow';
  },
};

export const validAnnouncementNumber = {
  validate(value) {
    return /^[A-Z0-9]*$/.test(value);
  },
};

export const hexColor = {
  validate(color) {
    return /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/.test(color);
  },
};
